import React from 'react';
import { Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { FaChevronRight } from "react-icons/fa";

const MobileMenuList = ({ menuItems }) => {
    return (
        <div className="mobile-menu-list">
            {menuItems.map((item, index) => (
                <CSSTransition
                    key={index}
                    in={true}
                    appear={true}
                    timeout={200 + (index * 50)} 
                    classNames="fade-in"
                >
                    <Link
                        to={`/${item.name.toLowerCase().replace(/\s+/g, "-")}`}
                        className="mobile-menu-item"
                        style={{
                            borderLeftColor: item.color
                        }}
                    >
                        <div
                            className="mobile-menu-icon"
                            style={{
                                color: item.color
                            }}
                        >
                            {item.icon}
                        </div>
                        <div className="mobile-menu-content">
                            <div className="mobile-menu-title">
                                {item.name === "Metrics" ? "Dashboard" : item.name}
                            </div>
                            <div className="mobile-menu-description">
                                {item.ethicalNote}
                            </div>
                        </div>
                        <div className="mobile-menu-arrow">
                            <FaChevronRight />
                        </div>
                    </Link>
                </CSSTransition>
            ))}
        </div>
    );
};

export default MobileMenuList; 